<template>
  <section class="skeleton featured">
    <div
      class="skeleton__box featured__content"
      :style="`background: linear-gradient(${$getGradient()})`"
    >
      <div class="featured__content-mask"></div>
      <h4 class="skeleton__title skeleton__animate--white featured__title"></h4>
      <p
        class="skeleton__content skeleton__animate--white featured__description"
      ></p>
      <p
        class="skeleton__content skeleton__animate--white featured__description"
      ></p>
      <p
        class="skeleton__content skeleton__animate--white featured__description"
      ></p>
      <div class="skeleton__box featured__details">
        <p
          class="skeleton__content skeleton__animate--white featured__detail"
        ></p>
        <p
          class="skeleton__content skeleton__animate--white featured__detail"
        ></p>
        <p
          class="skeleton__content skeleton__animate--white featured__detail"
        ></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturedSkel',
}
</script>

<style lang="scss" scoped>
.featured {
  min-height: 600px;
  margin: 0;
  width: 100%;
  &__content {
    height: 650px;
    padding: 150px 0 0 0;
    position: relative;
    @include mobile {
      padding: 150px 75px 0 75px;
    }
    @include desktop {
      padding: 150px 150px 0 150px;
    }
  }
  &__content-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0),
      rgba(21, 21, 21, 0.6),
      rgba(21, 21, 21, 1)
    );
    z-index: 0;
  }
  &__title {
    width: 400px;
    margin: 25px 0;
  }
  &__description {
    width: 1050px;
  }
  &__details {
    margin: 50px 0;
  }
  &__detail {
    margin: 10px 0;
    width: 700px;
  }
}
</style>
